import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setRuleName')(function setRuleName(newRuleName) {
    store.inboxRulesEditState.ruleName = newRuleName;
});
//# sourceMappingURL=setRuleName.js.map